import React from 'react';
import Ellipse from '@splunk/dashboard-visualizations/Ellipse';

export default () => <Ellipse options={{ fill: '#00ffff', fillOpacity: 0.5 }} />;
